import { doc } from "prettier";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import gsap from "gsap";

export const topMvSlider = () => {
  if (document.querySelector(".js-topmvslider") == undefined || document.querySelector(".js-topmvslider") == null)
    return;

  const loadingAnimation = () => {
    return new Promise((resolve, reject) => {
      // document.querySelector("#loading").classList.add("is-view");
      gsap
        .timeline()
        .to(".p-top-loading_logo", {
          opacity: 1,
          delay: 0.75,
        })
        .add(function () {
          document.querySelector("#loading").style.clipPath = "inset(0 0 0 100%)";
        });
      setTimeout(() => {
        document.querySelector("#loading").style.display = "none";
        resolve("success");
      }, 3700);
    });
  };

  window.addEventListener("DOMContentLoaded", () => {
    loadingAnimation().then(() => {
      if (document.querySelector(".js-topmvslider") != undefined) {
        const topslider = new Swiper(".js-topmvslider", {
          autoplay: {
            delay: 5000,
          },
          speed: 1000,
          effect: "fade",
          fadeEffect: {
            // crossFade: true
          },
        });

        document.querySelector(".p-top-mv").classList.add("is-view");
        document.querySelector(".p-top-mv_title").classList.add("is-active");
        document.querySelector(".p-top-mv_copy").classList.add("is-active");

        // setTimeout(function () {}, 4250);
      }
    });
  });
};
